import { MultiSelect } from 'core-components/library/multiSelect'
import { IStaticPropertiesMapping } from 'core-components/sitebuilder/models/IMetaInformation'
import { useStaticCrud } from 'core-components/types/helpers'

interface IMultiselectEditorProps {
  onChange: (newValue: string[]) => void
  dropdownItems?: IStaticPropertiesMapping['dropdownItems']
  dropdownSource?: IStaticPropertiesMapping['dropdownSource']
  paramName: string
  value: string[]
  className?: string
}

export const MultiSelectEditor = ({
  onChange,
  dropdownItems,
  dropdownSource,
  paramName,
  value,
  className,
}: IMultiselectEditorProps) => {
  const source = useStaticCrud({ data: dropdownItems || [] })

  if (!dropdownItems && !dropdownSource) {
    console.error(`The list of items is not set for this prop ${paramName}`)
    return null
  }

  return (
    <MultiSelect
      classes={{ controlClasses: { root: className } }}
      source={dropdownSource || source}
      label={'Parameter value'}
      onChange={onChange}
      value={value}
      caption={'value'}
    />
  )
}
